module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default; 
    ; __append("\r\n<div class=\"propDetail\" >\r\n    <div class=\"row\">\r\n        <div class=\"col-xs-2 prop-sublabel\">Name</div>\r\n        <div class=\"col-xs-10\"><input type=\"text\" name=\"text\" value=\"")
    ; __append(escapeFn( text ))
    ; __append("\" /></div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-xs-2 prop-sublabel\">Owner</div>\r\n        <div class=\"col-xs-10 prop-sublabel\">")
    ; __append(escapeFn( owner === "Form" ? "App" : owner ))
    ; __append("</div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-xs-2 prop-sublabel\">Status</div>\r\n        <div class=\"col-xs-10 prop-sublabel\">\r\n            <textarea id=\"status\" name=\"status\" disabled class=\"new-font-size\" style=\"overflow:hidden;\"></textarea>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-xs-12 prop-sublabel\">\r\n            <input type=\"checkbox\"  ")
    ; __append(escapeFn( u.isTrue(showProcessing) ? 'checked' : '' ))
    ; __append(" name=\"showProcessing\" class=\"form-radio-group\">\r\n            <label class=\"form-group-label\">Show Processing Message</label>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}